import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import locale from '../../common/locale'
import { escapeHtml } from '../../common/node'

export class NodeForm extends Component {

  constructor(props) {
    super(props);
    this.setPreview = this.setPreview.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.state = { preview: null };
  }

  setPreview(event) {
    this.setState({ preview: markdown_to_link(escapeHtml(event.target.value)) });
  }

  handleClick() {
    this.setState({ preview: null });
  }

  render() {
    const { handleSubmit, submitting, loc } = this.props
    return(
      <form onSubmit={handleSubmit} >
        <table>
          <tbody>
            <tr>
              <th>
                <Field className='node-textarea'
                  name='text' component='textarea'
                  onChange={this.setPreview} placeholder={locale.addNode(loc)} />
              </th>
              <th>
                <div className='node-textarea'>
                  <div className='content'>
                    <p dangerouslySetInnerHTML={{__html: this.state.preview}} />
                  </div>
                </div>
              </th>
            </tr>
            <tr>
              <th>
                <button className='btn' type="submit" disabled={submitting} onClick={this.handleClick} >
                  OK
                </button>
              </th>
              <th>
                <h5 className="left" >
                  {locale.example(loc)}<br/>{locale.linkExample(loc)}
                </h5>
              </th>
            </tr>
          </tbody>
        </table>
      </form>
    )
  }
}

const reg = new RegExp("\\[\(.*?\)\\]\\(\(http.*?\)\\)", 'g');

const markdown_to_link = text => {
  return( text.replace(reg, "<a href=\'" + "$2" + "\' target=\'_blank\'>" + "$1" + "</a>") )
}

export default reduxForm({
  form: 'nodeForm'
})(NodeForm)



// WEBPACK FOOTER //
// ./src/components/nodes/NodeForm.js